import styled, { css } from 'styled-components';
import { Layer } from '../layer/Layer.styled';
import { Icon } from '../styled-icon';
import { Label } from '../typographies';
import { SizeAddiFontXxSmall, SizeAddiFontSmall } from '@addi/foundation/dist/web/sizes';
import { FontAddiWeightMedium, FontAddiFamilyPrimaryName, FontAddiFamilySecondaryName } from '@addi/foundation/dist/web/fonts';
import { ColorAddiFontHint, ColorAddiFontError, ColorAddiCompFiveBase, ColorAddiFontPrimary, ColorAddiGrayLighten3, ColorAddiBackgroundSoft, } from '@addi/foundation/dist/web/colors';
export const ArrowIcon = styled(Icon) `
    position: absolute;
    top: 1.5rem;
    right: 8px;
    color: ${ColorAddiFontPrimary};
    font-size: ${SizeAddiFontXxSmall};
    z-index: 10;
    pointer-events: none;
    ${({ disabled }) => disabled &&
    css `color: ${ColorAddiFontHint}`}
`;
export const SelectIcon = styled(Icon) `
    position: absolute;
    top: 1.5rem;
    left: 8px;
    color: ${ColorAddiFontPrimary};
    font-size: ${SizeAddiFontXxSmall};
    z-index: 10;
    pointer-events: none;
    ${({ disabled }) => disabled &&
    css `color: ${ColorAddiFontHint}`}
`;
export const SelectLabel = styled(Label) `
    position: relative;
    transition-property: font-size;
    transition-duration: 4s;
    display: inline-flex;
    max-width: 150px;
    position: absolute;
    top: -2px;
    left: 0px;
    font-weight: normal;
    pointer-events: none;
`;
export const StyledSelect = styled.select `

    border: none;
    border: solid 1px ${({ isInvalid }) => isInvalid ? ColorAddiFontError : ColorAddiGrayLighten3};
    position: relative;
    box-sizing: border-box;
    background-color: transparent;
    width: 100%;
    height: 2rem;
    cursor: pointer;
    font-size: ${SizeAddiFontSmall};
    padding: 6px 24px;
    border-radius: 8px;
    box-sizing: border-box;
    -webkit-appearance: none;
    -moz-appearance: none;
    font-family: ${FontAddiFamilySecondaryName};
    font-weight: ${FontAddiWeightMedium};
    color: ${ColorAddiFontPrimary};

    &::-ms-expand {
        display: none;
    }

    &:focus {
        outline: none;

        border-color: ${ColorAddiCompFiveBase};
        border-width: 1px;

        ${SelectLabel} {
            color: ${ColorAddiFontPrimary};
        }
    }

    & option:disabled {
        color: ${ColorAddiFontHint};
    }

    ${props => props.disabled &&
    css `
            background: ${ColorAddiBackgroundSoft};
            cursor: auto;
            pointer-events: none;
            user-select: none;
            color: ${ColorAddiFontHint};

            & + ${SelectLabel} {
                color: ${ColorAddiFontHint};
            }
        `}

    & + ${SelectLabel} {
        display: flex;
        justify-content: space-between;
    }
`;
export const Optionals = styled(Layer) `
    display: flex;
    justify-content: space-between;
    background: transparent;
    padding: 0;
    border: none;
    margin-top: 0;
`;
export const Hint = styled(Label) `
    line-height: 14px;
    color: ${ColorAddiFontHint};
    width: 50%;
`;
export const Opts = styled(Label) `
    line-height: 14px;
    color: ${ColorAddiFontHint};
    width: 50%;
    text-align: right;
`;
export const Container = styled.div `
    padding: 1rem 0 0 0;
    background: transparent;
    width: ${props => (props.width ? props.width : '220px')};
    position: relative;
    font-family: ${FontAddiFamilyPrimaryName};
    font-weight: ${FontAddiWeightMedium};
`;
//# sourceMappingURL=Select.styled.js.map